module.exports = __webpack_public_path__ + "img/kong.96dc9302.png";